import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Pages/Footer/Footer';

const Main = () => {
    return (
        <div className='bg-gray-100 md:h-screen'>
            <div className='md:ml-[210px] lg:ml-[290px]'>
                <Outlet></Outlet>
            </div>
            <div class="flex items-end justify-end px-4 pb-6">
                <button class="fixed bottom-4 right-3 z-30 lg:hidden peer h-12 w-12 rounded-full bg-cyan-500 hover:bg-cyan-600 focus:bg-cyan-600 active:bg-cyan-700 transition">
                    <span class="text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 m-auto">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />
                        </svg>
                    </span>
                </button>

                <div class="z-20 fixed top-0 -left-96 lg:left-0 h-screen w-9/12 lg:w-72 bg-white shadow-2xl peer-focus:left-0 peer:transition ease-out delay-150 duration-200">
                    <nav role="navigation" class="p-6">
                        <div class="flex items-center justify-center">
                            <div className='bg-gray-200 px-3 py-3 rounded-3xl'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-12 h-12 text-primary-700">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
                                </svg>
                            </div>
                        </div>

                        <div className='flex justify-center mt-10'>
                            <button className='btn bg-primary-600 hover:bg-primary-700 px-5 py-2 rounded-lg text-lg font-bold text-white'>Request For</button>
                        </div>

                        <div class="mt-4 -mx-4 relative overflow-y-auto overflow-x-hidden h-[85vh]">
                            <ul class="space-y-4 mb-12 px-16 mt-8">
                                <li>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <img src="https://raw.githubusercontent.com/Meschacirung/Tailus-website/f59a4b3ecc1ad9f6a2b0ad9e3fca6f957140cc4d/public/images/icons/favorites.svg" class="w-6" alt="" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className='bg-primary-300 p-1 rounded-md'>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                        </svg>
                                        People
                                    </a>
                                </li>
                                <li>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M14.121 7.629A3 3 0 009.017 9.43c-.023.212-.002.425.028.636l.506 3.541a4.5 4.5 0 01-.43 2.65L9 16.5l1.539-.513a2.25 2.25 0 011.422 0l.655.218a2.25 2.25 0 001.718-.122L15 15.75M8.25 12H12m9 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>

                                        Finance
                                    </a>
                                </li>
                                <li>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <img src="https://raw.githubusercontent.com/Meschacirung/Tailus-website/f59a4b3ecc1ad9f6a2b0ad9e3fca6f957140cc4d/public/images/icons/atom.svg" class="w-6" alt="" />
                                        Documante
                                    </a>
                                </li>
                                <li>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <img src="https://raw.githubusercontent.com/Meschacirung/Tailus-website/f59a4b3ecc1ad9f6a2b0ad9e3fca6f957140cc4d/public/images/icons/molecule.svg" class="w-6" alt="" />
                                        Statistics
                                    </a>
                                </li>
                                <li>
                                    <a href="" class="flex gap-4 text-gray-600 hover:text-gray-800 transition">
                                        <img src="https://raw.githubusercontent.com/Meschacirung/Tailus-website/f59a4b3ecc1ad9f6a2b0ad9e3fca6f957140cc4d/public/images/icons/template.svg" class="w-6" alt="" />
                                        Calender
                                    </a>
                                </li>
                            </ul>
                            

                        </div>
                    </nav>
                </div>

                <div class="z-10 lg:hidden fixed top-0 left-0 w-screen h-screen bg-gray-900 bg-opacity-30 opacity-0 peer-focus:opacity-100 peer:transition duration-200"></div>
            </div>
        </div>
    );
};

export default Main;